var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.title)?_c('h4',{staticClass:"h4"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.text)?_c('MarkdownBlock',{attrs:{"text":_vm.text,"inline":false,"tag":"div"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }